import { __extends } from "tslib";
import * as React from "react";
import cx from "classnames";
import "./Label.css";
var Label = (function (_super) {
    __extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, children = _a.children, first = _a.first, htmlFor = _a.htmlFor, invalid = _a.invalid;
        var labelClass = cx("Label", {
            "Label--first": first,
            "Label--invalid": invalid
        });
        return (React.createElement("label", { htmlFor: htmlFor, className: labelClass }, children));
    };
    return Label;
}(React.Component));
export { Label };
export default Label;
